// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__19uyr","legacyBtn":"MutateMid_legacyBtn__35aU-"};